module.exports = __webpack_public_path__ + "img/DSC_2689-xs.5324ea07.png";